export const truncateToFixed = (value, decimals) => {
  // Multiply by the desired power of 10, truncate the decimal part, and then divide again
  const multiplier = Math.pow(10, decimals);
  return Math.floor(value * multiplier) / multiplier;
};

export function capitalizeFirstLetter(word) {
  if (!word) return "";
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}
